import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import { NineToFiveXNudgeSymbol, } from "../../reels/symbols/XNudgeSymbol";

// very scuffed for now
export class DoXNudge implements SimplePresentation {

    name:string = "RevealXWays";

    constructor() {
    }

    shouldRun():boolean {
        return this.getXNudgeSymbols().length > 0
    }

    // why :skull:
    private xNudgeSound(extraNudge:boolean = false): gsap.Callback {
       return () => {NineToFive.soundPlayer.playSoundNoOverlap(extraNudge ? "xNudgeNudgeLonger" : "xNudgeNudge")};
    }

    private getXNudgeSymbols():NineToFiveXNudgeSymbol[] {
        return (<NineToFiveXNudgeSymbol[]>NineToFive.baseGameReelView.getAllSymbols()).filter((sym) => sym.symbolName == "XN" && sym.isActualSymbol);
    }

    // TODO fix this absolutely disgusting code
    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        });
        tl.add(() => {
           controller.setSkipCallback(() => {
               tl.seek("NudgeEnd", false);
           })
        });
        const nudgeCounts:number[] = [0,0,0,0,0];
        const nudgeDowns:boolean[] = [false, false, false, false, false];
        NineToFive.model.bigSymbolData.forEach((data, index) => {
            if (!data.haveBigSymbol) {
                return;
            }
            let isFirstNudge = true;
            // nudge
            const currentSymbol = this.getXNudgeSymbols().filter((sym) => sym.reelID == index)[0];
            if (NineToFive.model.data.reels[index][0] == "XN") {
                nudgeCounts[index] = NineToFive.model.data.reels[index].reverse().indexOf("XN") - 1;
                nudgeDowns[index] = true;
                for (let i = 0; i < nudgeCounts[index]; i++){
                    const isFinalNudge = (i == (nudgeCounts[index] - 1));
                    tl.add(NineToFive.baseGameReelView.reelModels[index].nudge(false, isFinalNudge), isFirstNudge ? '>' : '>0.5');
                    tl.add(currentSymbol.tickUpMultiplier(), '<');
                    tl.add(this.xNudgeSound(), '<');
                    isFirstNudge = false;
                }
            } else if (NineToFive.model.data.reels[index][5] == "XN") {
                nudgeCounts[index] = NineToFive.model.data.reels[index].indexOf("XN") - 1;
                for (let i = 0; i < nudgeCounts[index]; i++){
                    const isFinalNudge = (i == (nudgeCounts[index] - 1));
                    tl.add(NineToFive.baseGameReelView.reelModels[index].nudge(true, isFinalNudge), isFirstNudge ? '>' : '>0.5');
                    tl.add(currentSymbol.tickUpMultiplier(), '<');
                    tl.add(this.xNudgeSound(), '<');
                    isFirstNudge = false;
                }
            }
            if (currentSymbol != undefined && nudgeCounts[index] > 0) {
                tl.add(NineToFive.baseGameReelView.playXNudgeExplosion(currentSymbol.reelID, !nudgeDowns[index]), '<');
            }
        });
        this.getXNudgeSymbols().forEach((sym) => {
            for (let i = 0; i < sym.maxMultiplier - nudgeCounts[sym.reelID] - 1; i++) {
                tl.add(sym.nudge(i + 1, nudgeDowns[sym.reelID]), '>0.7');
                tl.add(NineToFive.baseGameReelView.playXNudgeExplosion(sym.reelID, !nudgeDowns[sym.reelID]));
                tl.add(this.xNudgeSound(true), '<');
            }
        });

        tl.addLabel("NudgeEnd", this.getXNudgeSymbols()
                                    .some((sym) => (sym.maxMultiplier - nudgeCounts[sym.reelID] - 1) > 0) ? '<' : '>');
        tl.add(() => {
            controller.setSkipCallback(() => {})
        });
        tl.add(() => {}, '>0.5');
    }
}
